import React from 'react';
import { X } from 'lucide-react';

interface ImageModalProps {
  isOpen: boolean;
  imageData: string | null;
  onClose: () => void;
}

export default function ImageModal({ isOpen, imageData, onClose }: ImageModalProps) {
  if (!isOpen || !imageData) return null;

  return (
  <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
  <div className="relative text-black bg-uiBackground rounded-lg p-9 max-w-[80vw] max-h-[80vh] shadow-lg">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 p-1 bg-white bg-opacity-50 hover:bg-opacity-20 rounded-full"
          aria-label="Close"
        >
          <X size={20} />
        </button>
        <img
          src={`data:image/png;base64,${imageData}`}
          alt="Latest Visualization"
          className="max-w-[70vw] max-h-[70vh] rounded"
        />
      </div>
    </div>
  );
}
